export default "__VITE_ASSET__ADOz0EFm__"